import React from 'react';

export const serviceCashDeliveryConfig = [
  {
    path: '/service-cash-delivery-cpc-maker',
    component: React.lazy(() => import('./cpcMaker/listing/listing')),
  },
  {
    path: '/service-cash-delivery-cpc-maker/input-no-seal-overview',
    component: React.lazy(() => import('./cpcMaker/overview/detail')),
  },
  {
    path: '/service-cash-delivery-cpc-maker/input-no-seal',
    component: React.lazy(() => import('./cpcMaker/add/detail')),
  },
  {
    path: '/service-cash-delivery-cpc-maker/repair-no-seal-overview',
    component: React.lazy(() =>
      import('./cpcMakerRepairNoSeal/overview/index'),
    ),
  },
  {
    path: '/service-cash-delivery-cpc-maker/repair-no-seal',
    component: React.lazy(() => import('./cpcMakerRepairNoSeal/add')),
  },
  {
    path: '/service-cash-delivery-cit-executor',
    component: React.lazy(() => import('./cit/listing/listing')),
  },
  {
    path: '/service-cash-delivery-cit-executor/acceptance',
    component: React.lazy(() => import('./cit/acceptance/detail')),
  },
  {
    path: '/service-cash-delivery-cit-executor/checkin',
    component: React.lazy(() => import('./cit/checkIn/detail')),
  },
];
